import {gsap} from "../../libs/gsap/all.js";
import * as PIXI from "pixi.js";
import 'pixi.js/math-extras';

// Constructor
export class PlayerTile extends PIXI.Container {

  constructor(type) {
    super();

    this.type = type;
    this.originalTexture = "player-tile";

    this.dimension = {width: 286, height: 156};
    this.build();
  }

  build() {
    this.sprite = new PIXI.Sprite();

    if (this.type !== "player") {
      this.originalTexture = "player-unselected-tile";
    }

    this.sprite.texture = app.game.assets[this.originalTexture];
    this.sprite.anchor.set(0.5);

    this.addChild(this.sprite);
  }

  highlight(highlight = false) {
    if (this.type !== "player") {
      if (highlight) {
        this.sprite.texture = app.game.assets["player-selected-tile"];
      } else {
        this.sprite.texture = app.game.assets[this.originalTexture];
      }
    }
  }

  changeState(active = false) {
    gsap.to(this, {
      pixi: {
        alpha: active ? 1 : 0
      },
      duration: 0.5,
      ease: "power1.inOut",
    })
  }

  // blink() {
  //   gsap.fromTo(this.highlightSprite, {
  //     pixi: {alpha: 1},
  //   }, {
  //     pixi: {alpha: 0},
  //     duration: 0.75,
  //     ease: "power1.in"
  //   })
  // }

  // Reset the states so we can animate in again and start over
  reset() {
  }


}
